const baseURL = import.meta.env.VITE_APP_API_BASE_URL

export const API = {
  API: {
    TOKEN: {
      INDEX: `${baseURL}api/token/`,
      REFRESH: `${baseURL}api/token/refresh/`
    }
  },
  ROLES: {
    INDEX: `${baseURL}roles/`
  },
  SECTION_GEO_DATA: {
    GET_FIELD_NAMES: `${baseURL}section_geo_data/get_field_names/`,
    SECTION_LINE_UPLOAD_COLLECTIONS: {
      INDEX: `${baseURL}section_geo_data/section_line_upload_collections/`,
      UPLOAD_TO_PROJECT: (projectId: number) =>
        `${baseURL}section_geo_data/section_line_upload_collections/upload_to_project/${projectId}/`,
      IMPORT_FROM_SPECKLE: `${baseURL}section_geo_data/section_line_upload_collections/import_speckle/`,
      EXPORT_TO_SPECKLE: `${baseURL}section_geo_data/section_line_upload_collections/export_speckle/`
    },
    SECTION_LINES: {
      INDEX: `${baseURL}section_geo_data/section_lines/`,
      UPLOAD_POLYGON_SHAPEFILE: `${baseURL}section_geo_data/section_lines/upload_polygon_shapefile/`
    },
    SECTION_LINES_GI_POINTS: {
      INDEX: `${baseURL}section_geo_data/section_lines_gi_points/`
    },
    SELECTION_POLYGONS: {
      INDEX: `${baseURL}section_geo_data/section_selection_polygons/`
    },
    RASTER_FILE_UPLOAD: {
      INDEX: `${baseURL}section_geo_data/raster_file_uploads/`
    }
  },
  GI_DATA: {
    GI_DATA_UPLOAD_COLLECTIONS: {
      INDEX: `${baseURL}gi_data/gi_data_upload_collections/`,
      SPECKLE_IMPORT_META: `${baseURL}gi_data/gi_data_upload_collections/speckle-import-meta/`,
      IMPORT_FROM_SPECKLE: `${baseURL}gi_data/gi_data_upload_collections/import-speckle/`,
      TASK_STATUS: (taskId: string) =>
        `${baseURL}gi_data/gi_data_upload_collections/task-status/${taskId}/`,
      UPLOAD_CLASSIFICATION_DATA: `${baseURL}gi_data/gi_data_upload_collections/upload-classification/`,
      GET_CLASSIFICATION_DATA: `${baseURL}gi_data/gi_data_upload_collections/classification-overview/`,
      UPDATE_CLASSIFICATION_DATA: `${baseURL}gi_data/gi_data_upload_collections/update-classification-colors/`,
      DOWNLOAD_TEMPLATE: `${baseURL}gi_data/gi_data_upload_collections/classification-upload-template/`
    },
    GI_POINTS: {
      INDEX: `${baseURL}gi_data/gi_points/`
    },
    IMPORT_FROM_SPECKLE: {
      INDEX: `${baseURL}gi_data/import_speckle/`
    }
  },
  BOREHOLE_DATA: {
    BOREHOLE_SAMPLE_OBSERVATION: {
      INDEX: `${baseURL}borehole_data/borehole_sample_observations/`
    },
    SELECTED_VISUALIZATION_COLUMN: {
      INDEX: `${baseURL}borehole_data/selected_visualization_columns/`
    }
  },
  SPECKLE: {
    BASE: `${baseURL}core/speckle/`
  },
  OPENGROUND: {
    EXPORT_OPENGROUND_TO_SPECKLE: `${baseURL}gi_data/openground/export_to_speckle/`,
    TASK_STATUS: (taskId: string) => `${baseURL}gi_data/openground/task-status/${taskId}/`,
    GI_LOCATIONS: `${baseURL}gi_data/openground/gi_locations/`,
    PROJECT_METADATA: `${baseURL}gi_data/openground/project_metadata/`,
    ACCESS_TOKEN: `${baseURL}gi_data/openground/access_token/`
  },
  CORE: {
    PROJECTS: {
      INDEX: `${baseURL}core/projects/`,
      GET_UPLOAD_URI: `${baseURL}core/projects/get_upload_uri/`
    },
    PROJECT_USERS: {
      INDEX: `${baseURL}core/project_users/`
    },
    USERS: {
      INDEX: `${baseURL}core/users/`,
      CURRENT_USER: `${baseURL}core/users/current_user`
    }
  }
}

export default API
